// extracted by mini-css-extract-plugin
export var about = "about-module--about--23-oY";
export var writing = "about-module--writing--3AJLY";
export var imageSection = "about-module--imageSection--3Zeq3";
export var myImage = "about-module--myImage--1Kcny";
export var paragraphSection = "about-module--paragraphSection--3WivP";